function cleanLabel(label) {
  if (typeof label !== "string") {
    return label;
  }

  return label.replace(/\s*\(LEGAL NAME\)?/gi, "").trim();
}

export default cleanLabel;
